import { render } from "./Espaco.vue?vue&type=template&id=43e76d0b"
import script from "./Espaco.vue?vue&type=script&lang=js"
export * from "./Espaco.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__